import React from 'react';
import AltIso from 'alt/utils/AltIso';
import {Link} from 'react-router';
import DashboardHeader from '../components/DashboardHeader';
import Calendar from '../components/Calendar/Calendar';
import moment from 'moment';
import 'moment-timezone';
import _ from 'lodash';
import reportTime from '../utils/reportTime';
import FinishModal from '../components/FinishModal';

import DashboardWelcome from '../views/DashboardWelcome';
import DashboardOverview2 from './DashboardOverview2';

import connectToStores from 'alt/utils/connectToStores';

import GlobalActions from '../actions/GlobalActions';
import SeoActions from '../actions/SeoActions';
import ShiftActions from '../actions/ShiftActions';

import GlobalStore from '../stores/GlobalStore';
import ShiftStore from '../stores/ShiftStore';
import FullReport from "../components/FullReport";

@AltIso.define((props) => {
    return Promise.all([
        new Promise((resolve) => {
            SeoActions.pushTitle('Dashboard');
            resolve();
        }),
        ShiftStore.hasShifts(),
        ShiftStore.getShiftsToFinish()
    ]);
})
@connectToStores
class DashboardOverview extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showFinishShiftModal: false,
            selected: moment().startOf("day"),
            month: moment().startOf("day"),
            showCalendar: true,
            finishedShifts: [],
            componentHasLoaded: false,
            selectedTab: 'agenda'
        };
    }

    static getPropsFromStores() {
        return {
            globalStore: GlobalStore.getState(),
            shiftStore: ShiftStore.getState()
        };
    }

    static getStores() {
        return [ShiftStore, GlobalStore];
    }

    dom(ref) {
        // Helper function to wrap getDOMNode
        return React.findDOMNode(this.refs[ref]);
    }

    resetScroll() {
        this.dom("invisiscroller").scrollTop = this.dom('topdummy').scrollHeight;
    }

    componentDidMount() {
        const selectedTab = this.props.globalStore.dashboardTab;
        let month = null;
        let selected = null;
        // The initial value in GlobalStore is somehow cached in server (express) and probably needs packages update!?
        // Since we don't want to invest more time into fixing the issues in the project and update the packages we need
        // to use the following hack to detect the last active date.
        if (this.props.globalStore.activeDashboardDate === null) {
            month = moment().startOf('day');
            selected = month.clone();
            GlobalActions.saveDashboardDate(month.clone());
        } else {
            month = moment(this.props.globalStore.activeDashboardDate).startOf('day');
            selected = moment(this.props.globalStore.activeDashboardDate).startOf('day');
        }
        ShiftStore.getShifts(month);
        ShiftStore.getShiftsFullReport(month);

        // Scroll it down by dummy length (Changed to 1px to prevent scrolling, R.I.P my cool scrolling animations thx Ivar)
        if (this.props.shiftStore.shiftCount !== 0) {
            React.findDOMNode(this.refs['invisiscroller']).scrollTop = 1;
        }
        const remindLaterIds = this.readCookie('remind_later_ids').length > 0 ? JSON.parse(this.readCookie('remind_later_ids')) : this.readCookie('remind_later_ids');
        this.setState({finishedShifts: remindLaterIds, componentHasLoaded: true, selectedTab, month, selected});
    }

    componentWillUnmount() {
        ShiftActions.clearShifts();
        ShiftActions.clearFinishedShifts();
    }

    mapShifts(list) {
        let days = {},
            results = [];
        // First let's group events by day
        list.forEach(shift => {
            const start_time = moment(shift.start_time).tz(shift.company.timezone),
                end_time = moment(shift.end_time).tz(shift.company.timezone),
                date = moment(shift.start_time).tz(shift.company.timezone).startOf("day"),
                message_count = shift.message_count;

            // Don't render if it's before the selected date
            const selected_date = moment.tz(this.state.selected.format('YYYY-MM-DD'), shift.company.timezone);
            if (date < selected_date) {
                return;
            }

            const displayed_date = start_time.format('dddd D'),
                isFull = shift.candidates_hired == shift.workers_needed,
                isDraft = shift.status == "draft",
                isCompleted = end_time < moment() || shift.status == 'ended',
                isFinished = shift.status == "finished",
                isCancelled = shift.status == 'cancelled';
            let note, titleStyles = "shift-title dot";

            // Note
            note = isCancelled ? <span className="note">Cancelled</span> : isDraft ?
                <span className="note">Draft</span> : isFinished ?
                <span className="note">Finished</span> : isCompleted ?
                <span className="note">Please finish this shift</span> : "";

            // Dot color
            if(isCompleted && !isFinished && !isCancelled && !isDraft) {
                titleStyles = `${titleStyles} dot-orange`;
            } else if (isDraft) {
                titleStyles = `${titleStyles} dot-gray`;
            } else if (isFull || isFinished || isCancelled) {
                titleStyles = `${titleStyles} dot-green`;
            } else {
                // if published
                titleStyles = `${titleStyles} dot-orange`;
            }

            const linkTo = isCompleted && !isFinished && !isCancelled && !isDraft ? 'finish_shift' : 'shift';

            let shiftBlock = (
                <Link to={linkTo} params={{shiftId: shift.id}} className="shift" key={shift.id}>
                    <h4 className={titleStyles}>{shift.position ? shift.workers_needed : ''} {shift.position ? shift.position.name : ''} {shift.workers_needed && shift.position ? '-' : ''} {shift.venue} {note}</h4>

                    <div className="shift-info">
                        Hired: {shift.candidates_hired}{shift.workers_needed ? '/' : ''}{shift.workers_needed} |{' '}
                        <span className={shift.candidates_pending ? "text-alert" : ""}>
                            Candidates: {shift.candidates_pending}
                        </span>
                        {' '}| {reportTime(start_time, end_time)}
                    </div>
                    {(message_count > 0 && !(isCompleted && !isFinished) ?
                        <div className="shift-circle"><span>{message_count}</span></div> : '')}
                    <div className="shift-arrow"></div>
                </Link>
            );
            if (days[displayed_date]) {
                days[displayed_date].push(shiftBlock);
            } else {
                days[displayed_date] = [shiftBlock]
            }
        });

        // And now output the daily list
        if (Object.keys(days).length > 0) {
            for (const date in days) {
                if (days.hasOwnProperty(date)) {
                    results.push(
                        <div ref={date} key={`d${date}`} className="agenda-day">
                            <h3 className="day-title">{date}</h3>
                            {days[date]}
                        </div>
                    );
                }
            }
        } else {
            results.push(
                <div ref="emptyAgenda" className="empty-agenda">
                    <div className="empty-info">
                        <div className="map"></div>
                        <div className="empty-title">You have gone too far!</div>
                        <p>There are no shifts after the date you selected. Do you want to create a shift on this
                            date?</p>
                        <Link to="createshift" className="btn btn-green btn-new-shift">New shift</Link>
                    </div>
                </div>
            )
        }

        return results;
    }

    getSelection(date) {
        this.resetScroll();
        this.setState({
            selected: date,
        });
        GlobalActions.saveDashboardDate(date);
    }

    monthChangeCallback(date) {
        ShiftStore.getShiftsFullReport(date);
        ShiftStore.getShifts(date);
        GlobalActions.saveDashboardDate(date);
    }

    addFinishedShift(shiftId) {
        let finishedShift = this.state.finishedShifts;
        finishedShift.push(shiftId);
        this.setState({finishedShift});
    }

    getFinishedShifts(shifts) {
        const endedHoursAgo = (shift) => {
            const endTime = moment(shift.end_time).tz(shift.company.timezone);
            const currTime = moment().tz(shift.company.timezone);
            return moment.duration(currTime.diff(endTime)).asHours();
        };
        return _.filter(shifts, shift => {
            return this.state.finishedShifts.indexOf(shift.id) === -1
                && shift.candidates_hired > 0
                && endedHoursAgo(shift) >= 24
                && this.state.componentHasLoaded;
            }) || [];
    }


    remindLater(shiftId) {
        let remindLaterIds = this.readCookie('remind_later_ids').length > 0 ? JSON.parse(this.readCookie('remind_later_ids')) : this.readCookie('remind_later_ids');
        remindLaterIds.push(shiftId);
        remindLaterIds = JSON.stringify(remindLaterIds);
        this.createCookie('remind_later_ids', remindLaterIds, 2);
    }

    readCookie(name) {
        const nameEQ = encodeURIComponent(name) + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return [];
    }

    createCookie(name, value, days) {
        let expires;

        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
    }

    changeTab(selectedTab) {
        this.setState({selectedTab});
        GlobalActions.saveDashboardTab(selectedTab);
    }

    prevMonth() {
        const newMonth = this.state.month.add(-1, "M");
        const selected = this.state.selected.add(-1, "M").startOf("M");
        this.monthChangeCallback(newMonth);
        this.setState({
            month: newMonth,
            selected,
        });
    }

    nextMonth() {
        const newMonth = this.state.month.add(1, "M");
        const selected = this.state.selected.add(1, "M").startOf("M");
        this.monthChangeCallback(newMonth);
        this.setState({
            month: newMonth,
            selected,
        });
    }

    select(day) {
        const state = {};
        if (day.isNextMonth) {
            state.month = this.state.month.add(1, "M");
            this.monthChangeCallback.call(this, state['month']);
        } else if (day.isPrevMonth) {
            state.month = this.state.month.add(-1, "M");
            this.monthChangeCallback.call(this, state['month']);
        }
        this.getSelection.call(this, day.date);
        this.setState(state);
        this.forceUpdate();
    }

    calendarToggle() {
        this.setState({
            showCalendar: !this.state.showCalendar
        });
    }

    render() {
        let shifts = this.props.shiftStore.shifts;
        let fullReport = this.props.shiftStore.fullReport;
        const shiftsToFinish = this.props.shiftStore.shiftsToFinish;

        // If no shifts, render empty state
        if (this.props.shiftStore.shiftCount === 0) return this.renderEmptyState();

        const calendar = (headerOnly) => (
            <Calendar month={this.state.month} shifts={shifts}
                prevMonth={this.prevMonth.bind(this)}
                nextMonth={this.nextMonth.bind(this)}
                select={this.select.bind(this)}
                selected={this.state.selected}
                iconClick={this.calendarToggle.bind(this)}
                className={this.state.showCalendar ? '' : 'calendar-hidden'}
                headerOnly={headerOnly}
            />
        );

        const agenda = () => (
            <div className="view-content maxwidth-wrapper">
                <div className="media">
                    {calendar()}
                    <div className="agenda-week body">
                        <div ref="invisiscroller" className="invisi-scroll">
                            <div ref="whitebox" className="whitebox">
                                <div ref="topdummy"
                                     className={`agenda-dummy hide`}></div>
                                {this.mapShifts(shifts)}
                                <div ref="botdummy" className={`agenda-dummy bottom`}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        const week = () => (
            <DashboardOverview2
                selected={this.state.selected}
                shifts={shifts}
                monthChangeCallback={this.monthChangeCallback.bind(this)}
                prevMonth={this.prevMonth.bind(this)}
                nextMonth={this.nextMonth.bind(this)}
                month={this.state.month}
            />
        );

        const report = () => (
            <div className="view-content maxwidth-wrapper">
                <div className="media">
                    {calendar(true)}
                    <div className="whitebox">
                        <FullReport fullReport={fullReport} date={this.state.month}/>
                    </div>
                </div>
            </div>
        );

        const selectedTab = this.state.selectedTab;

        return (
            <div className={"view-dashboard-" + (selectedTab == 'week' ? "overview2" : "overview")}>
                <DashboardHeader
                    query={this.props.query}
                    isPro={this.props.isPro()}
                    changeTab={this.changeTab.bind(this)}
                    selectedTab={this.state.selectedTab}
                />

                {this.state.selectedTab == 'agenda' ? agenda() : null}
                {this.state.selectedTab == 'week' ? week() : null}
                {this.state.selectedTab == 'report' ? report() : null}

                <FinishModal toggleModal={this.toggleFinishShiftModal.bind(this)}
                             isVisible={this.getFinishedShifts(shiftsToFinish).length}
                             shift={this.getFinishedShifts(shiftsToFinish)}
                             addFinishedShift={this.addFinishedShift.bind(this)}
                             remindLater={this.remindLater.bind(this)}
                             shiftId={this.props.params.shiftId}/>
            </div>
        );
    }

    toggleFinishShiftModal(shiftId, forceClose, callback) {
        let finishedShifts;
        if (forceClose) {
            finishedShifts = this.props.shiftStore.shiftsToFinish.map((shift => shift.id));
        } else {
            finishedShifts = this.state.finishedShifts;
            finishedShifts.push(shiftId);
        }
        this.setState({
            showFinishShiftModal: !this.state.showFinishShiftModal,
            finishedShifts
        }, callback);
    }

    renderEmptyState() {
        return <DashboardWelcome {...this.props} />;
    }
}

export default DashboardOverview;



/** WEBPACK FOOTER **
 ** ./app/src/views/DashboardOverview.js
 **/